import { Box } from '@mui/system';
import { useTranslation } from 'react-i18next';
import { Route,Routes } from 'react-router-dom';
import { GenericTitleHeader } from '../component/common/GenericTitleHeader';
import { VehicleToBeRepairedTable } from '../component/vehicle-To-Be-repaired/VehicleToBe Repaired';
import SectionHeader from "../../../util/component/SectionHeader";
import React from "react";
const VehicleToBeRepairedPage = () => {
    const { t } = useTranslation(["operation"]);
    return (
        <div>
            <SectionHeader
                title={t("vehicleToBeRepaired.firstTitle") + " " + t("vehicleToBeRepaired.secondTitle")}
            />
            <Routes><Route path="/"  element={<VehicleToBeRepairedTable/>}/></Routes></div>
           
    );
}

export default VehicleToBeRepairedPage;